export default "__VITE_PUBLIC_ASSET__2899d351__"